$(function () {
    Cookies.remove("smartbanner-closed");
    Cookies.remove("smartbanner-installed");

    let ripples = $('.mdc-button').map(function (index, el) {
        return new window.mdc.ripple.MDCRipple(el);
    });

    let listRipples = $('.mdc-list-item').map(function(index, el) {
        return new window.mdc.ripple.MDCRipple(el);
    });

    let fabRipples = $('.mdc-fab').map(function(index, el) {
        return new window.mdc.list.MDCList(el);
    });

    let lists = $('.mdc-list').map(function(index, el) {
        return new window.mdc.list.MDCList(el);
    });

    window.appDialog = $('#app-dialog')[0].MDCDialog;

    //Top App Bar Menu button Handle
    $('.mdc-top-app-bar')[0].MDCTopAppBar.listen('MDCTopAppBar:nav', function () {
        let drawer = $('.mdc-drawer')[0].MDCDrawer;
        drawer.open = !drawer.open;
    });

    //Tab arrow handle
    $('.tab-arrow').on('click', function (e) {
        let tabBarAdapter = document.querySelector('.mdc-tab-bar').MDCTabBar.getDefaultFoundation().adapter_;
        let isLeft = $(this).hasClass('tab-arrow-left');
        let current = tabBarAdapter.getPreviousActiveTabIndex();

        let next = isLeft ? current - 1 : current + 1;

        tabBarAdapter.setActiveTab(next);
    });
    themeChanged();
});

let image = $('img');

image.on('load',function () {
    this.style.display = 'inline-block';
});

image.on('error', function (event) {
    this.style.display = 'none';
});

//Smart-banner
window.banner = new SmartBanner({
    daysHidden: 90, // days to hide banner after close button is clicked (defaults to 15)
    daysReminder: 15, // days to hide banner after "VIEW" button is clicked (defaults to 90)
    appStoreLanguage: 'hk', // language code for the App Store (defaults to user's browser language)
    title: 'POPsale',
    author: 'shoppingGAI Company Limited',
    button: '下載',
    store: {
        ios: '即刻去App Store下載啦',
        android: '即刻去Play Store下載啦',
        windows: 'In Windows store'
    },
    price: {
        ios: '免費',
        android: '免費',
    },
    icon: "{{ asset('img/popsale-smart-banner-icon.png') }}",
    theme: 'etc',
});

//Theme-data
window.themeS = $('.theme-data');

//Theme Handler
window.getActiveTab = function() {
    return $('.mdc-tab.mdc-tab--active');
};

window.themeChanged = function() {
    let color = themeS.data('theme-color');
    let icon = themeS.data('theme-icon');
    let cate = themeS.data('cate-id');
    let zone = themeS.data('zone-id');

    if (window.vm.$refs.builder && cate) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        window.vm.$refs.builder.category = cate;
        window.vm.$refs.builder.initRequest = `/popsale/api/v1/offer/search?cat=${cate}&ads=1`
    }

    // if (window.vm.$refs.adsBuilder) {
    //     if (zone) {
    //         window.vm.$refs.adsBuilder.zone = zone;
    //     } else {
    //         window.vm.$refs.adsBuilder.zone = null;
    //     }
    // }

    if (color) {
        document.documentElement.style.setProperty('--mdc-theme-primary', color);
    } else {
        document.documentElement.style.setProperty('--mdc-theme-primary', '#76cec5');
    }

    if (icon && icon !== window.location.hostname) {
        $('section.app-title a img').each( function (i, e) {
            $(e).attr('src', icon);
        });
    } else {
        $('section.app-title a img').each( function (i, e) {
            $(e).attr('src', '/img/popsale/header-icons/popsale-horizontal.png')
        });
    }
};

window.insertCheckBox = function(id, className, isChecked) {
    return `<div class="mdc-checkbox">
                        <input type="checkbox"
                               class="${className} mdc-checkbox__native-control" data-id="${id}" ${isChecked ? 'checked' : ''}/>
                        <div class="mdc-checkbox__background">
                          <svg class="mdc-checkbox__checkmark"
                               viewBox="0 0 24 24">
                            <path class="mdc-checkbox__checkmark-path"
                                  fill="none"
                                  d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                          </svg>
                          <div class="mdc-checkbox__mixedmark"></div>
                        </div>
                    </div>`
};

window.promptAppDialog = function () {
    window.appDialog.open();
};

//Extension
//FromData
FormData.prototype.removeEmptyAttrs = function () {
    let pendingToDel = [];

    for (let item of this.entries()) {
        if (!item[1]) {
            pendingToDel.push(item[0])
        }
    }

    for (let item of pendingToDel) {
        this.delete(item);
    }
};

/** Form status button click */
$('.form-status > .form-status__button').on('click', function (event) {
    let check = 'fa-check-square';
    let uncheck = 'fa-square';

    let isCheck = $(this).children().hasClass(check);

    /** Update form value and layout*/
    for(let i = 0; i < $(this).children().length; i++) {
        let el = $(this).children()[i];
        if ($(el).is('input[type="hidden"]')) {
            $(el).val(!isCheck);
        }
        /** Update layout */
        if ($(el).hasClass('mdc-button__icon')) {
            $(el).removeClass( isCheck ? check : uncheck);
            $(el).addClass( isCheck ? uncheck : check);
        }
    }
});

/** Custom Dialog */
$('div.dialog').on('click', function (e) {
    if ( e.target !== e.currentTarget) {
        return;
    }
    $(this).hide();
});